import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { reservePublishedBanner } from '../../config/publicChrome';

const ChromeReservation = createContext(() => {});
export const useChromeReservation = () => useContext(ChromeReservation);

// Admin and bare review retain no public wrapper/chrome. Route classes are presentation only.
export const PublicFrame = ({ enabled, home, path = '', children }) => enabled ? <div className={`idb-public ${home ? 'idb-public-home' : 'idb-family-inner'} idb-route-${path.replace(/^\//, '').replace(/[^a-z0-9-]/gi, '-') || 'home'}`}><a href="#idb-main-content" className="idb-skip-link" data-testid="skip-to-content">Skip to content</a>{children}</div> : <>{children}</>;

export const PublicChrome = ({ enabled, hasBanner = true, children }) => {
  const ref = useRef(null);
  const [reserve, setReserve] = useState(reservePublishedBanner);
  useEffect(() => {
    const el = ref.current;
    if (!enabled || !el || !window.ResizeObserver) return;
    const root = el.closest('.idb-public');
    const update = () => root?.style.setProperty('--idb-public-chrome-height', `${el.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [enabled]);
  return enabled ? <ChromeReservation.Provider value={setReserve}><div ref={ref} className={`idb-public-chrome ${hasBanner && reserve ? 'idb-chrome-reserved' : ''}`}>{children}</div></ChromeReservation.Provider> : <>{children}</>;
};
